import querystring from 'querystring';
import url from 'url';
import { notificationsSelector } from '../selectors';

const notificationEndpoint = url.parse(
    `${
        process.env.JEST_API_HOST || ''
    }/api/2/patient/setpatientnotificationsseen`
);

export const Actions = {
    MARK_NOTIFICATIONS_SEEN_STARTED: '@@Layout/MARK_NOTIFICATIONS_SEEN_STARTED',
    MARK_NOTIFICATIONS_SEEN_SUCCEEDED:
        '@@Layout/MARK_NOTIFICATIONS_SEEN_SUCCEEDED',
    MARK_NOTIFICATIONS_SEEN_FAILED: '@@Layout/MARK_NOTIFICATIONS_SEEN_FAILED',
};

const markNotificationSeen = () => ({
    type: Actions.MARK_NOTIFICATIONS_SEEN_STARTED,
});

const markNotificationSeenSuccess = () => ({
    type: Actions.MARK_NOTIFICATIONS_SEEN_SUCCEEDED,
});

const markNotificationSeenFailure = () => ({
    type: Actions.MARK_NOTIFICATIONS_SEEN_FAILED,
});

export function notificationIds(notifications = []) {
    return notifications.reduce((ids, { seen, id }) => {
        if (!seen && id) {
            return [...ids, id];
        } else {
            return ids;
        }
    }, []);
}

export function markNotificationsSeen() {
    return (dispatch, getState) => {
        const state = getState();

        const notifications = notificationsSelector(state);
        const ids = notificationIds(notifications);
        if (ids.length === 0) {
            return;
        }

        const query = querystring.stringify({ ids: ids.join(',') });

        const requestUrl = `${url.format(notificationEndpoint)}?${query}`;
        const options = {
            method: 'GET',
            credentials: 'include',
        };

        dispatch(markNotificationSeen());

        return fetch(requestUrl, options)
            .then((response) => {
                switch (response.status) {
                    case 200:
                        dispatch(markNotificationSeenSuccess());
                        break;
                    default:
                        dispatch(markNotificationSeenFailure());
                }
            })
            .catch(() => {
                return dispatch(markNotificationSeenFailure());
            });
    };
}
